module.exports = __webpack_public_path__ + "media/images/bus/conditions/WIFI-4b3412a3d9dd6e3e9f30df2b26d0b75d.svg";